'use strict'

import ApiClient from './ApiClient'

export default class PersonRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 名刺人物一覧情報を取得します。
   * @param {object} data 検索条件のbody情報
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  postSearch (data, isMgmt) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }
    delete data.page
    delete data.sort_item
    delete data.direction
    // 名刺管理の場合は、管理モードフラグを付ける
    this.setMgmtParam(isMgmt, params)

    return ApiClient().post(`/persons`, data, { params })
  }

  /**
   * 編集画面用に既存人物の名刺情報を取得する
   * @param {number} person_id
   * @param {bool} isMgmt 管理モードフラグ
   */
  get (person_id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/persons/${person_id}`, { params })
  }

  /**
   * 名刺詳細情報を取得します
   * @param {object} params
   * @param {bool} isMgmt 管理モードフラグ
   */
  getOverall (params, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    params = this.setMgmtParam(isMgmt, params)
    return ApiClient().get(`/persons/overview`, { params })
  }

  /**
   * 指定された人物IDの名刺情報（と関連情報）を取得します。
   * @param {string|int} person_id 人物ID
   * @param {string|int} bcard_id  名刺ID 0:最新
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getBcard (person_id, bcard_id, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/persons/${person_id}/bcards/${bcard_id}`, { params })
  }

  /**
   * 指定された人物IDの最新名刺情報（と関連情報）を取得します。
   * @param {string|int} person_id 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getLatestBcard (person_id, isMgmt) {
    return this.getBcard(person_id, 0, isMgmt)
  }

  /**
   * 直接入力画面から同一人物候補を取得します
   * @param data
   * @returns {*}
   */
  postSearchDups (data) {
    return ApiClient().post(`/persons/duplicates`, data)
  }

  /**
   * 公開設定、タグ、TwitterID、ブログURL、共有メモを更新します。
   * 1つだけ更新する場合はそれぞれ、putOpenflag()、putTags()、putMemo()推奨
   * @param {string|int} id 人物ID
   * @param {object} params
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  put (id, params, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    return ApiClient().put(`/persons/${id}`, params, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * 公開設定を更新します。
   * @param {string|int} id 人物ID
   * @param {string} openflag 公開フラグ
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  putOpenflag (id, openflag, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    return ApiClient().put(`/persons/${id}`, { openflag }, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * タグを更新します。
   * @param {string|int} id 人物ID
   * @param {array} tags タグIDs
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  putTags (id, tags, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    return ApiClient().put(`/persons/${id}`, { tags }, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * ソーシャルサイトの内容を取得します。
   * @param {string|int} id 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getSocialInfo (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/persons/${id}/social`, { params })
  }

  /**
   * 共有メモの内容を取得します。
   * @param {string|int} id 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getMemo (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/persons/${id}/memo`, { params })
  }

  /**
   * 共有メモの内容を更新します。
   * @param {string|int} id 人物ID
   * @param {string} memo
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  putMemo (id, memo, isMgmt) {
    return ApiClient().put(`/persons/${id}`, { memo }, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * 最新名刺IDを更新します。
   * @param {string|int} id 人物ID
   * @param {string} memo
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  putNewId (id, new_id, isMgmt) {
    return ApiClient().put(`/persons/${id}`, { new_id }, {params: this.setMgmtParam(isMgmt)})
  }

  /**
   * 個人メモの内容を取得します。
   * @param {string|int} id 人物ID
   * @returns {*}
   */
  getPvMemo (id) {
    return ApiClient().get(`/persons/${id}/pvmemo`)
  }

  /**
   * 個人メモの内容を更新します。
   * @param {string|int} id 人物ID
   * @param {string} memo
   * @returns {*}
   */
  putPvMemo (id, memo) {
    return ApiClient().put(`/persons/${id}/pvmemo`, { memo })
  }

  /**
   * 検索キーワードの内容を取得します。
   * @param {string|int} id 人物ID
   * @returns {*}
   */
  getKeywords (id) {
    return ApiClient().get(`/persons/${id}/pvkeywords`)
  }

  /**
   * 検索キーワードの内容を取得します。
   * @param {string|int} id 人物ID
   * @param {object} params キーワードの連想配列
   * @returns {*}
   */
  putKeywords (id, params) {
    // let params = {}
    // for (let i = 1, len = 10; i <= len; i++) {
    //   params['keyword' + ('' + i).padStart(2, '0')] = keywords.shift()
    // }
    return ApiClient().put(`/persons/${id}/pvkeywords`, params)
  }

  /**
   * 兼務情報一覧を取得します。
   * @param {string|int} id 人物ID
   * @param {object} params
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getConcposts (id, params, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    params = this.setMgmtParam(isMgmt, params)
    return ApiClient().get(`/persons/${id}/concposts`, { params })
  }

  /**
   * 新しい兼務情報を追加します。
   * @param {string|int} id 人物ID
   * @param {string|int} sid_assign 兼務人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  postConcpost (id, sid_assign, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().post(`/persons/${id}/concposts`, { sid_assign }, { params })
  }

  /**
   * 指定された兼務情報を解除します。
   * @param {string|int} id 人物ID
   * @param {string|int} sid_assign 兼務人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  removeConcpost (id, sid_assign, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().delete(`/persons/${id}/concposts/${sid_assign}`, { params })
  }

  /**
   * 交換者一覧を取得します。
   * @param {string|int} id 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getExchangers (id, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/persons/${id}/exchangers`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/PersonRepository.js